module.exports = __webpack_public_path__ + "static/media/light-recent-source.1c622a8c.svg";